import { ReactNode } from "react";

import { useRouter } from "next/router";

import { Tabs } from "antd";
import styled from "styled-components";

const StyledTabs = styled(Tabs)<{ offset?: number; activecolor?: string; bgcolor?: string; hide?: string }>`
  display: ${(props) => (props.hide == "true" ? "none" : "block")};

  .ant-tabs-content-holder {
    background: ${(props) => props.activecolor || props.theme.colorBgContainer};
    margin-bottom: 16px;
  }

  .ant-tabs-tab {
    border: none !important;
    background: transparent !important;
  }

  .ant-tabs-tab-active {
    background: ${(props) => props.activecolor || props.theme.colorBgContainer} !important;
  }

  .ant-tabs-nav {
    margin: 0;
    position: sticky;
    top: 0;
    background: ${(props) => props.bgcolor || props.theme.colorBgLayout} !important;
    z-index: 2;

    :before {
      border: none;
    }
  }
`;

interface TabItem {
  label: ReactNode;
  key: string;
  children: ReactNode;
  disabled?: boolean;
  urlParams?: { [key: string]: string | number | boolean };
}
const TabLayout = ({
  hide,
  views,
  destroyInactiveTabPane = true,
  updateUrl = true,
  activecolor,
  bgcolor,
  callback,
  activeTab,
  defaultTab,
}: {
  hide?: boolean;
  views: TabItem[];
  offset?: number;
  destroyInactiveTabPane?: boolean;
  updateUrl?: boolean;
  activecolor?: string;
  bgcolor?: string;
  callback?: (key: string) => void;
  activeTab?: string;
  defaultTab?: string;
}) => {
  const router = useRouter();

  const { tab } = router.query;

  return (
    <StyledTabs
      type="card"
      hide={`${hide}`}
      defaultActiveKey={defaultTab}
      activeKey={activeTab || tab?.toString() || undefined}
      activecolor={activecolor}
      bgcolor={bgcolor}
      items={views}
      destroyInactiveTabPane={destroyInactiveTabPane}
      onTabClick={(page: string) => {
        if (callback) {
          callback(page);
        }

        if (updateUrl) {
          const urlParams = views.find((row) => row.key === page)?.urlParams;
          const convertURLParamsToString = urlParams
            ? Object.keys(urlParams).map((key) => {
                return `&${key}=${urlParams[key]}`;
              })
            : "";

          const id = router?.query?.id?.toString();
          const asPath = `${router.pathname}?tab=${page}${convertURLParamsToString}`.replace("[id]", `${id}`);
          const url = {
            pathname: router.pathname,
            query: { ...router.query, tab: page, ...urlParams, search: undefined },
          };

          router.push(url, asPath, { shallow: true });
        }
      }}
    />
  );
};

export default TabLayout;
